import {
  DESIGN_DNA_MOODBOARD_URL,
  DESIGN_DNA_USER_PROMPT,
} from './designDnaDemoContent.js'

/** @param {string} trimmed */
function normalizeDesignDnaPrompt(trimmed) {
  return trimmed.trim().replace(/\s+/g, ' ').toLowerCase()
}

/** @param {string} trimmed */
export function isDesignDnaDemoPrompt(trimmed) {
  const normalized = normalizeDesignDnaPrompt(trimmed)
  if (normalized === normalizeDesignDnaPrompt(DESIGN_DNA_USER_PROMPT)) {
    return true
  }
  return (
    normalized.includes('figma') &&
    (normalized.includes('mui') || normalized.includes('material ui')) &&
    (normalized.includes('moodboard') ||
      normalized.includes('pinterest') ||
      normalized.includes(DESIGN_DNA_MOODBOARD_URL.toLowerCase()))
  )
}
